import './MeterBarChart.css';
export var inlineValueVariants = {left:'_116rojq3-3-15-1 _116rojq2-3-15-1',right:'_116rojq4-3-15-1 _116rojq2-3-15-1'};
export var wrapperVariants = {shown:'_116rojq0-3-15-1',hidden:'_116rojq1-3-15-1'};